export default "/images/55047f50b7f532bc519635ba236935c4.avif";